import { gql } from "@apollo/client";

const AUTH_USER_FIELDS = `
  id
  email
  firstName
  lastName
  role
  isEmailVerified
  isManagedSupport
  managedSupportRole
  avatar
  preferences {
    theme
    notifications {
      email
      push
    }
  }
  twoFactor {
    enabled
    enabledAt
    recoveryCodesRemaining
  }
  organizations {
    id
    name
    domain
    security {
      twoFactorRequired
      twoFactorRequiredRoles
      twoFactorEnforcedAt
    }
    members {
      role
      user {
        id
        email
        firstName
        lastName
      }
    }
    subscription {
      plan
      status
      billingCycle
      currentPeriodStart
      currentPeriodEnd
      usage {
        code
        count
        limit
        limitExceeded
        lastUsageAt
      }
    }
    usage {
      code
      count
      lastUsageAt
    }
    billingCurrency
    outboundCallingEnabled
    isShopifyManaged
    shopifyBillingRequired
    shopifyShopDomain
  }
  createdAt
  updatedAt
`;

export const LOGIN = gql`
  mutation Login($input: LoginInput!) {
    login(input: $input) {
      token
      refreshToken
      expiresIn
      requiresTwoFactor
      challengeToken
      twoFactorSetupRequired
      user {
        ${AUTH_USER_FIELDS}
      }
    }
  }
`;

export const REGISTER = gql`
  mutation Register($input: RegisterInput!) {
    register(input: $input) {
      token
      refreshToken
      expiresIn
      user {
        ${AUTH_USER_FIELDS}
      }
    }
  }
`;

export const PUBLIC_SIGNUP_ENABLED = gql`
  query PublicSignupEnabled {
    publicSignupEnabled
  }
`;

export const REFRESH_TOKEN = gql`
  mutation RefreshToken($token: String!) {
    refreshToken(token: $token) {
      token
      refreshToken
      expiresIn
      user {
        ${AUTH_USER_FIELDS}
      }
    }
  }
`;
